import { Button, Flex } from "antd";
import { useTranslation } from "react-i18next";

interface FailedToLoadProps {
  resource?: string;
  onRetry?: () => void;
}

export const FailedToLoad = ({ resource = "", onRetry }: FailedToLoadProps) => {
  const { t } = useTranslation(["common"]);

  return (
    <Flex align="center" gap="middle">
      <div>
        {t("common:errors.failedToLoad", {
          defaultValue: `Failed to load this resource: ${resource}`,
          resource,
        })}
      </div>
      {onRetry && (
        <Button onClick={onRetry}>
          {t("common:components.buttons.retry")}
        </Button>
      )}
    </Flex>
  );
};
